import React from "react";
import "../../../../styles/Pages/Operational/Residential/Tuition/Tuition.style.css";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import TogglePushBtn from "../../../../components/Universal/TogglePushBtn.component";
import FilterBtn from "../../../../components/Universal/FilterBtn.component";
import { ReactComponent as PersonIcon } from "../../../../assets/Icons/Universal/Person.svg";
import { ReactComponent as PersonInMobileIcon } from "../../../../assets/Icons/Universal/PersonInMobile.svg";
import SearchIcon from "../../../../assets/Icons/Universal/Search.svg";

import TuitionBody from "../../../../components/PagesComponents/Operational/Residential/Tuition/TuitionBody.component";
import TuitionHistory from "../../../../components/PagesComponents/Operational/Residential/Tuition/TuitionHistory.component";

const Body = ({
  filter,
  setFilter,
  classesFilter,
  setClassesFilter,
  lineChartData,
  studentDetailsModal,
  setStudentDetailsModal,
  editScheduleModal,
  setEditScheduleModal,
  editModalShiftChange,
  setEditModalShiftChange,
  changeTuitionPage,
  setChangeTuitionPage,

  // setLineChartData,
}) => {
  // const [totalScroll, setTotalScroll] = useState(0);

  // const ScrollX = () => {
  //   // if (scrollableContainer) {
  //   //   setTotalScroll(
  //   //     totalScroll -
  //   //       scrollableContainer?.current.offsetWidth /
  //   //         scrollableContainer?.current.children.length +
  //   //       16
  //   //   );
  //   //   scrollableContainer?.current.setAttribute(
  //   //     "style",
  //   //     `transform:translateX(${
  //   //       totalScroll -
  //   //       scrollableContainer?.current.offsetWidth /
  //   //         scrollableContainer?.current.children.length +
  //   //       16
  //   //     }px);transition:0.5s`
  //   //   );
  //   //   console.log(totalScroll);

  //   //   console.log(
  //   //     scrollableContainer?.current.offsetWidth /
  //   //       scrollableContainer?.current.children.length +
  //   //       16
  //   //   );
  //   // }
  // };
  return (
    <section className="tuitionPage pr-1 h-fit">
      <PageHeader
        title={changeTuitionPage ? "Tuition history" : "Tuition"}
        renderCustomElement={
          <div
            className="flex-row align-center justify-start g-05"
            style={{ flexWrap: "wrap" }}
          >
            <TogglePushBtn
              type="radio"
              setVal={(val) =>
                setFilter({
                  ...filter,
                  gender: val.toLowerCase(),
                })
              }
              name="examreportToggle"
              value={filter.gender}
              icon={
                <PersonIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="All"
            />
            <TogglePushBtn
              type="radio"
              setVal={(val) =>
                setFilter({
                  ...filter,
                  gender: val.toLowerCase(),
                })
              }
              name="examreportToggle"
              value={filter.gender}
              icon={
                <PersonInMobileIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="Boys"
            />
            <TogglePushBtn
              type="radio"
              setVal={(val) =>
                setFilter({
                  ...filter,
                  gender: val.toLowerCase(),
                })
              }
              name="examreportToggle"
              value={filter.gender}
              icon={
                <PersonInMobileIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="Girls"
            />
            <div className="flex">
              <FilterBtn
                btnTitle={"Filter"}
                filterArray={[
                  "Class I",
                  "Class II",
                  "Class III",
                  "Class IV",
                  "Class V",
                ]}
                setFilteredData={(val) => setClassesFilter(val)}
                filteredData={classesFilter}
              />
            </div>

            <div className="flex-col g-05 align-start justify-end">
              <div className="searchInputContainer">
                <input
                  type="text"
                  className="pageHeaderInput"
                  placeholder="Type for search"
                />
                <button className="searchBtn">
                  <img src={SearchIcon} alt="searchBtn" />
                </button>
              </div>
            </div>

            <TogglePushBtn
              type="checkbox"
              name="myToggle"
              label="Tuition history"
              value={changeTuitionPage ? "Tuition history" : ""}
              setVal={() => {
                setChangeTuitionPage((prev) => !prev);
              }}
              initialBackColor="#E4E0FF"
              initialColor="#5E4DE1"
              checkedBackColor="#5E4DE1"
              initialBorderColor="#5E4DE1"
              lableStyle={{ fontSize: "13px" }}
              btnStyle={{ height: "calc(100% - 4px)" }}
            />
          </div>
        }
      />
      {changeTuitionPage ? (
        <TuitionHistory />
      ) : (
        <TuitionBody
          filter={filter}
          setFilter={setFilter}
          classesFilter={classesFilter}
          setClassesFilter={setClassesFilter}
          lineChartData={lineChartData}
          studentDetailsModal={studentDetailsModal}
          setStudentDetailsModal={setStudentDetailsModal}
          editScheduleModal={editScheduleModal}
          setEditScheduleModal={setEditScheduleModal}
          editModalShiftChange={editModalShiftChange}
          setEditModalShiftChange={setEditModalShiftChange}
        />
      )}
    </section>
  );
};

export default Body;
